
const data =  [
    {
      id: "750644",
      imageId: "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
      action: {
        link: "https://www.swiggy.com/collections/80441?collection_id=80441&tags=layout_CCS_Idli&type=rcv2",
        text: "Idli",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for idly",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80441&tags=layout_CCS_Idli",
      frequencyCapping: {},
    },
    {
      id: "749879",
      imageId:
        "v1674029844/PC_Creative%20refresh/3D_bau/banners_new/Chole_Bature.png",
      action: {
        link: "https://www.swiggy.com/collections/80383?collection_id=80383&tags=layout_CCS_CholeBhature&type=rcv2",
        text: "Chole Bhature",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for chhole bhatoore",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80383&tags=layout_CCS_CholeBhature",
      frequencyCapping: {},
    },
    {
      id: "750132",
      imageId: "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
      action: {
        link: "https://www.swiggy.com/collections/80426?collection_id=80426&tags=layout_CCS_Dosa&type=rcv2",
        text: "Dosa",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for dosa",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80426&tags=layout_CCS_Dosa",
      frequencyCapping: {},
    },
    {
      id: "749789",
      imageId:
        "v1674029849/PC_Creative%20refresh/3D_bau/banners_new/Omelette.png",
      action: {
        link: "https://www.swiggy.com/collections/80468?collection_id=80468&tags=layout_BAU_Contextual%2Comelette&type=rcv2",
        text: "Omelette",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for omelette",
        altTextCta: "open",
      },
      entityId: "80468",
      frequencyCapping: {},
    },
    {
      id: "750235",
      imageId:
        "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Sandwich.png",
      action: {
        link: "https://www.swiggy.com/collections/83667?collection_id=83667&tags=layout_CCS_Sandwiches&type=rcv2",
        text: "Sandwich",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for sandwich",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=83667&tags=layout_CCS_Sandwiches",
      frequencyCapping: {},
    },
    {
      id: "750237",
      imageId: "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Poori.png",
      action: {
        link: "https://www.swiggy.com/collections/80378?collection_id=80378&tags=layout_BAU_Contextual%2Cpoori&type=rcv2",
        text: "Poori",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for poori",
        altTextCta: "open",
      },
      entityId: "80378",
      frequencyCapping: {},
    },
    {
      id: "750203",
      imageId:
        "v1674029853/PC_Creative%20refresh/3D_bau/banners_new/Paratha.png",
      action: {
        link: "https://www.swiggy.com/collections/80476?collection_id=80476&tags=layout_BAU_Contextual%2Cparatha%2Cads_pc_paratha&type=rcv2",
        text: "Paratha",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for paratha",
        altTextCta: "open",
      },
      entityId: "80476",
      frequencyCapping: {},
    },
    {
      id: "750217",
      imageId:
        "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
      action: {
        link: "https://www.swiggy.com/collections/80364?collection_id=80364&tags=layout_PavBhaji_Contextual&type=rcv2",
        text: "Pav Bhaji",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for pav bhaji",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80364&tags=layout_PavBhaji_Contextual",
      frequencyCapping: {},
    },
    {
      id: "750231",
      imageId: "v1674029857/PC_Creative%20refresh/3D_bau/banners_new/Poha.png",
      action: {
        link: "https://www.swiggy.com/collections/80374?collection_id=80374&tags=layout_CCS_Poha&type=rcv2",
        text: "Poha",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for poha",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80374&tags=layout_CCS_Poha",
      frequencyCapping: {},
    },
    {
      id: "750640",
      imageId:
        "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Kachori.png",
      action: {
        link: "https://www.swiggy.com/collections/80450?collection_id=80450&tags=layout_BAU_Contextual%2Ckachori&type=rcv2",
        text: "Kachori",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for kachori",
        altTextCta: "open",
      },
      entityId: "80450",
      frequencyCapping: {},
    },
    {
      id: "749791",
      imageId:
        "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Pakodas.png",
      action: {
        link: "https://www.swiggy.com/collections/80470?collection_id=80470&tags=layout_BAU_Contextual%2Cpakoda&type=rcv2",
        text: "Pakoda",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for pakoda",
        altTextCta: "open",
      },
      entityId: "80470",
      frequencyCapping: {},
    },
    {
      id: "750230",
      imageId:
        "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png",
      action: {
        link: "https://www.swiggy.com/collections/80397?collection_id=80397&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
        text: "Samosa",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for samosa",
        altTextCta: "open",
      },
      entityId: "80397",
      frequencyCapping: {},
    },
    {
      id: "750123",
      imageId:
        "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Dhokla.png",
      action: {
        link: "https://www.swiggy.com/collections/80423?collection_id=80423&tags=layout_BAU_Contextual%2Cdhokla&type=rcv2",
        text: "Dhokla",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for dhokla",
        altTextCta: "open",
      },
      entityId: "80423",
      frequencyCapping: {},
    },
    {
      id: "750572",
      imageId:
        "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
      action: {
        link: "https://www.swiggy.com/collections/80439?collection_id=80439&tags=layout_CCS_PureVeg&type=rcv2",
        text: "Pure Veg",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for veg",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=80439&tags=layout_CCS_PureVeg",
      frequencyCapping: {},
    },
    {
      id: "750544",
      imageId: "v1674029842/PC_Creative%20refresh/3D_bau/banners_new/Upma.png",
      action: {
        link: "https://www.swiggy.com/collections/80412?collection_id=80412&tags=layout_BAU_Contextual%2Cupma&type=rcv2",
        text: "Upma",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for upma",
        altTextCta: "open",
      },
      entityId: "80412",
      frequencyCapping: {},
    },
    {
      id: "750078",
      imageId:
        "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Coffee.png",
      action: {
        link: "https://www.swiggy.com/collections/83660?collection_id=83660&tags=layout_CCS_Coffee&type=rcv2",
        text: "Coffee",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurants curated for coffee",
        altTextCta: "open",
      },
      entityId:
        "swiggy://collectionV2?collection_id=83660&tags=layout_CCS_Coffee",
      frequencyCapping: {},
    },
    {
      id: "749763",
      imageId: "v1674029844/PC_Creative%20refresh/3D_bau/banners_new/Lassi.png",
      action: {
        link: "https://www.swiggy.com/collections/80459?collection_id=80459&tags=layout_BAU_Contextual%2Classi&type=rcv2",
        text: "Lassi",
        type: "WEBLINK",
      },
      entityType: "BANNER",
      accessibility: {
        altText: "restaurant curated for lassi",
        altTextCta: "open",
      },
      entityId: "80459",
      frequencyCapping: {},
    },
  ];

  export default data